import api from '../../../configs/instanceApi';

export const getConditions = async () => {
  const url = `/accreditation-quotations/quotations/term-data`;
  return api.get(url);
};
